import React from "react";

function MinusIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 12h14"></path>
    </svg>
  );
}

export default MinusIcon;
